import { ReactNode } from 'react';

export class DropdownOption<Value = number> {
  public readonly value: Value;
  public readonly label: string;
  public readonly shortLabel: string;
  public readonly postfixType?: 'new' | 'soon' | 'info';
  public readonly tooltipTitle?: ReactNode;
  public readonly disabled?: boolean;

  public constructor(
    value: Value,
    label: string,
    shortLabel = label,
    disabled?: boolean,
    postfixType?: 'new' | 'soon' | 'info',
    tooltipTitle?: ReactNode,
  ) {
    this.value = value;
    this.label = label;
    this.shortLabel = shortLabel;

    if (disabled !== null) {
      this.disabled = disabled;
    }

    if (postfixType) {
      this.postfixType = postfixType;
    }

    if (tooltipTitle) {
      this.tooltipTitle = tooltipTitle;
    }
  }

  public checkIsActive(values: Array<Value>): boolean {
    return values.includes(this.value);
  }
}
